<template>
    <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        :item-value="itemValue"
        density="comfortable"
        class="elevation-0"
        fixed-header
        height="420"
    >
        <template #top>
            <div class="pa-2">
                <v-text-field
                    :model-value="search"
                    label="Search"
                    prepend-inner-icon="mdi-magnify"
                    density="compact"
                    hide-details
                    single-line
                    clearable
                    variant="outlined"
                    @update:model-value="$emit('update:search', $event)"
                />
            </div>
        </template>

        <template v-if="navigateTo === 'project'" #item.projectName="{ item }">
            <v-tooltip
                v-if="!canOpenProject(item.projectId)"
                location="top"
                :open-delay="1000"
            >
                <template #activator="{ props }">
                    <span
                        v-bind="props"
                        class="stats-name-disabled"
                    >
                        {{ item.projectName }}
                    </span>
                </template>
                <span>
                    You do not have permissions to navigate to this project
                </span>
            </v-tooltip>
            <span
                v-else
                class="stats-name-link"
                @click.stop="openProject(item.projectId)"
            >
                {{ item.projectName }}
            </span>
        </template>

        <template v-if="navigateTo === 'user'" #item.userName="{ item }">
            <span
                class="stats-name-link"
                @click.stop="openUser(item.userId)"
            >
                {{ item.userName }}
            </span>
        </template>

        <template #item.users="{ item }">
            <CountWithNamesTooltip
                :count="item.users"
                :names="item.userNames"
            />
        </template>
        <template #item.projects="{ item }">
            <CountWithNamesTooltip
                :count="item.projects"
                :names="item.projectNames"
            />
        </template>
    </v-data-table>
</template>

<script>
import { mapGetters } from "vuex";
import CountWithNamesTooltip from "@/components/CountWithNamesTooltip.vue";
import { canAccessProject } from "@/utils/projectUtils";
import {
    navigateToUserInfo,
    navigateToProjectInfo,
} from "@/utils/utils";

export default {
    name: "StatisticsResultsTable",
    components: { CountWithNamesTooltip },
    props: {
        headers: { type: Array, required: true },
        items: { type: Array, required: true },
        itemValue: { type: String, required: true },
        search: { type: String, default: "" },
        /**
         * Make the primary name column navigate like other tables.
         * - "project" → ProjectInfo (with access check)
         * - "user" → UserInfo
         */
        navigateTo: {
            type: String,
            default: null,
            validator: (v) => v == null || v === "user" || v === "project",
        },
    },
    emits: ["update:search"],
    computed: {
        ...mapGetters({
            rights: "getRights",
            managedProjects: "getManagedProjects",
        }),
    },
    methods: {
        canOpenProject(projectId) {
            return canAccessProject(
                projectId,
                this.rights,
                this.managedProjects
            );
        },
        openProject(projectId) {
            if (!this.canOpenProject(projectId)) return;
            navigateToProjectInfo(this.$router, projectId);
        },
        openUser(userId) {
            navigateToUserInfo(this.$router, userId);
        },
    },
};
</script>

<style scoped>
.stats-name-link {
    cursor: pointer;
}
.stats-name-link:hover {
    text-decoration: underline;
}
.stats-name-disabled {
    cursor: not-allowed;
    opacity: 0.6;
}
</style>
